import Avatar from 'assets/svg/icon-avatar/ic-avatar.svg'
import { WEB_DESKTOP_RALALI_URL } from 'common/constants'
import theme from 'common/theme'
import highlighter from 'lib/highlighter'
import { ISuggestionItem } from 'services/Product/stores/models/SearchSuggestionModel/interface'
import styled from 'styled-components'

const HighlitedText = styled.p`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const StyledListItemResult = styled.li`
  background-color: ${(props) =>
    props.isHighlited ? theme.colors.grayLighter : ''};
  display: flex;
`

function Seller({
  suggestionItem,
  keywords,
  isHighlited,
}: ISuggestionItem): JSX.Element {
  const handleItemClick = () => {
    window.location.assign(
      `${WEB_DESKTOP_RALALI_URL}/v/${suggestionItem.alias}`,
    )
  }

  return (
    <StyledListItemResult
      onClick={handleItemClick}
      isHighlited={isHighlited}
      data-testid="seller-item"
    >
      <Avatar />
      <HighlitedText
        dangerouslySetInnerHTML={{
          __html: highlighter(suggestionItem.name, keywords),
        }}
        data-testid="seller-item-text"
      />
    </StyledListItemResult>
  )
}

export default Seller
